module.exports = __webpack_public_path__ + "static/img/1.8ffc3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/4/1.png
// module id = JmBS
// module chunks = 1